export default class Auth {
    /**
     * @param {AuthStorage} authStorage
     * @param {string} token
     */
    constructor(authStorage, token) {
        this.authStorage = authStorage;
        this.token = token;
        this.errorHandler = false;
        this.redirectEndpoint = '';
    }

    redirect() {
        window.location.replace(this.redirectEndpoint);
    }

    /**
     * @return {boolean}
     */
    hasRedirectEndpoint() {
        return this.redirectEndpoint.length > 0;
    }

    /**
     * @param {Function} method
     */
    setErrorHandler(method) {
        this.errorHandler = method;
    }

    /**
     * @return {boolean}
     */
    hasErrorHandler() {
        return this.errorHandler !== false;
    }

    /**
     * @param {string} username
     * @param {string} password
     * @param {string} endpoint
     */
    login(username, password, endpoint) {
        this.notify(endpoint, {
            login: username,
            password,
        });
    }

    /**
     * @param {string} email
     * @param {string} secretKey
     * @param {string} endpoint
     */
    refresh(email, secretKey, endpoint) {
        this.notify(endpoint, {
            email,
            secret: secretKey,
        });
    }

    /**
     * @param {string} endpoint
     * @param {Object} data
     */
    notify(endpoint, data) {
        const handler = new XMLHttpRequest();

        handler.open('POST', endpoint);
        handler.setRequestHeader('x-csrf-token', this.token);
        handler.setRequestHeader('Content-Type', 'application/json');
        handler.setRequestHeader('Accept', 'application/json');

        handler.onload = () => {
            if (handler.status === 200) {
                const response = JSON.parse(handler.responseText);
                this.redirectEndpoint = response.data.redirect;

                if (this.redirectEndpoint !== null) {
                    this.redirect();
                }
            } else if (this.hasErrorHandler()) {
                this.errorHandler(handler.status);
            }
        };

        handler.send(JSON.stringify(data));
    }

    logout(endpoint) {
        const handler = new XMLHttpRequest();

        handler.open('DELETE', endpoint);
        handler.setRequestHeader('x-csrf-token', this.token);
        handler.setRequestHeader('Accept', 'application/json');

        handler.onload = () => {
            if (handler.status === 200) {
                const response = JSON.parse(handler.responseText);
                this.redirectEndpoint = response.data.redirect;

                this.redirect();
            }
        };

        handler.send();
    }

    /**
     * @param {Object} response
     */
    addCredentials(response) {
        this.authStorage.putSecret(response.data.secret);
        this.authStorage.putEmail(response.data.email);
    }
}
